import InternalUserInfoForm from "@/components/administeredUsers/InternalUserInfoForm";
import * as Nested from "@/util/Nested";
import * as AlertBarState from "@/components/alert-bar/AlertBar.state";
import { getState as getCurrentUser } from "@/components/currentUser/CurrentUser.state";

export const OPEN_CHANGE_PASSWORD_FORM = "profilePage/OPEN_CHANGE_PASSWORD_FORM";
export const openChangePasswordForm = () => ({
  type: OPEN_CHANGE_PASSWORD_FORM,
});

export const HANDLE_RESET_PASSWORD_URL = "profilePage/HANDLE_RESET_PASSWORD_URL";
export const handleResetPasswordUrl = (url) => ({
  type: HANDLE_RESET_PASSWORD_URL,
  payload: { url },
});

export const SUBMIT_PROFILE_FORM = "profilePage/SUBMIT_PROFILE_FORM";
export const submitProfileForm = (payload) => ({
  type: SUBMIT_PROFILE_FORM,
  payload,
});

export const SUBMIT_PROFILE_FORM_SUCCESS = "profilePage/SUBMIT_PROFILE_FORM_SUCCESS";
export const submitProfileFormSuccess = () => ({
  type: SUBMIT_PROFILE_FORM_SUCCESS,
});

export const SUBMIT_CHANGE_PASSWORD_FORM_FAILURE =
  "profilePage/SUBMIT_CHANGE_PASSWORD_FORM_FAILURE";
export const submitChangePasswordFormFailure = () => ({
  type: SUBMIT_CHANGE_PASSWORD_FORM_FAILURE,
});

export const SUBMIT_PROFILE_FORM_FAILURE = "profilePage/SUBMIT_PROFILE_FORM_FAILURE";
export const submitProfileFormFailure = () => ({
  type: SUBMIT_PROFILE_FORM_FAILURE,
});

export const CLOSE_PROFILE_FORM = "profilePage/CLOSE_PROFILE_FORM";
export const closeProfileForm = ({ history }) => ({
  type: CLOSE_PROFILE_FORM,
  payload: { history },
});

const INITIAL_STATE = {
  submitting: false,
  resetPasswordUrl: false,
};

export const _reducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SUBMIT_PROFILE_FORM:
      return {
        ...state,
        submitting: true,
      };
    case SUBMIT_PROFILE_FORM_SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case SUBMIT_PROFILE_FORM_FAILURE:
      return {
        ...state,
        submitting: false,
      };
    case HANDLE_RESET_PASSWORD_URL:
      return {
        ...state,
        resetPasswordUrl: payload.url,
      };
    default:
      return state;
  }
};

export const _mapStateToProps = (state) => ({
  ...state.profilePage,
  currentUserState: getCurrentUser(state),
});
export const _mapDispatchToProps = (dispatch) => ({
  closeProfileForm: (payload) => dispatch(closeProfileForm(payload)),
  handleResetPasswordUrl: (url) => dispatch(handleResetPasswordUrl(url)),
  openChangePasswordForm: () => dispatch(openChangePasswordForm()),
  submitChangePasswordFormFailure: () => dispatch(submitChangePasswordFormFailure()),
  submitProfileForm: (payload) => dispatch(submitProfileForm(payload)),
  submitProfileFormFailure: () => dispatch(submitProfileFormFailure()),
  submitProfileFormSuccess: () => dispatch(submitProfileFormSuccess()),
});

export const PROFILE_PAGE_ALERT_BAR_ACTION =
  "profilePage/PROFILE_PAGE_ALERT_BAR_ACTION";
export const profilePageAlertBarAction = Nested.nestedAction(
  PROFILE_PAGE_ALERT_BAR_ACTION
);

export const EDIT_PROFILE_ALERT_BAR_ACTION =
  "profilePage/EDIT_PROFILE_ALERT_BAR_ACTION";
export const editProfileAlertBarAction = Nested.nestedAction(
  EDIT_PROFILE_ALERT_BAR_ACTION
);
export const PROFILE_FORM_ACTION = "profilePage/PROFILE_FORM_ACTION";
export const profileFormAction = Nested.nestedAction(PROFILE_FORM_ACTION);

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      profileForm: {
        ...InternalUserInfoForm,
        actionType: PROFILE_FORM_ACTION,
      },
    },
    alertBars: {
      profilePageAlertBar: {
        ...AlertBarState,
        actionType: PROFILE_PAGE_ALERT_BAR_ACTION,
      },
      editProfileAlertBar: {
        ...AlertBarState,
        actionType: EDIT_PROFILE_ALERT_BAR_ACTION,
      },
    },
  },
  "profilePage"
);

const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
